export default {
  SMALL_MOBILE_BREAKPOINT: '370px',
  MOBILE_BREAKPOINT: '568px',
  DESKTOP_BREAKPOINT: '768px',
  SIDEBAR_MIN_BREAKPOINT: '1160px',
  TITLE_DEFAULT: 'Checkout | John Lewis & Partners',
  TITLE_EXPIRY_WARNING: '** Session expiring **',
  ROOT: 'root',
  COUNTRIES: 'countries',
  DELIVERY_INSTRUCTIONS: [{
    label: 'Additional directions',
  }, {
    label: 'Lift or stairs access',
  }, {
    label: 'Access restrictions',
  }, {
    label: 'Someone else accepting delivery',
  }, {
    label: 'I need extra time',
  }, {
    label: 'I have vision impairments',
  }, {
    label: 'I have hearing impairments',
  }, {
    label: 'Other',
  }],
  PERSIST_ROOT: 'persist:root',
  CALL_CENTRE_NUMBERS: {
    standard: '03456 049 049',
    enhanced: '03456 100 383',
    partnership: '0330 175 9829',
  },
  BFF_TIMEOUT: 35000,
  AUTH0_TOKEN_TIMEOUT: 10,
  CHECKOUT_AUTH0_TOKEN_TIMEOUT: 10000,
};
